var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c(
        "v-card-title",
        [
          _c("span", { staticClass: "text-h5" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.skip } },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-container",
        { staticClass: "p-4" },
        [
          _c(
            "v-row",
            { staticClass: "text-caption" },
            [
              _vm._l(_vm.resources.skier_types, function(item, index) {
                return [
                  _c("v-col", { attrs: { cols: "12", md: "4" } }, [
                    _c("h5", [
                      _vm._v("TYPE " + _vm._s(_vm.toRoman(index + 1)))
                    ]),
                    _vm._v(" "),
                    _c("h6", [_vm._v(_vm._s(item.title))]),
                    _vm._v(" "),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(
                          (item.content || "")
                            .replaceAll("\\r", "")
                            .replaceAll("\\n", "")
                        )
                      }
                    })
                  ])
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6",
                    md: _vm.reservee_gender ? 4 : 6
                  }
                },
                [
                  _c("with-validation", {
                    attrs: { field: "full_name" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  { attrs: { autocomplete: "off" } },
                                  "v-text-field",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "6",
                    md: _vm.reservee_gender ? 4 : 6
                  }
                },
                [
                  _c("with-validation", {
                    attrs: { field: "dob" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c("v-text-field", {
                              directives: [
                                {
                                  name: "mask",
                                  rawName: "v-mask",
                                  value: "##/##/####",
                                  expression: "'##/##/####'"
                                }
                              ],
                              attrs: {
                                autocomplete: "off",
                                label: bind.label,
                                error: bind.error,
                                "error-messages": bind.errorMessages,
                                placeholder: "mm/dd/yyyy",
                                "prepend-icon": "mdi-calendar"
                              },
                              on: {
                                blur: function($event) {
                                  _vm.saveDob()
                                  _vm.validate(["dob"])
                                }
                              },
                              model: {
                                value: _vm.tmpDob,
                                callback: function($$v) {
                                  _vm.tmpDob = $$v
                                },
                                expression: "tmpDob"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.reservee_gender
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "4" } },
                    [
                      _c("with-validation", {
                        staticClass: "mt-0",
                        attrs: { field: "gender" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var bind = ref.bind
                                var on = ref.on
                                return [
                                  _c(
                                    "v-radio-group",
                                    _vm._g(
                                      _vm._b(
                                        { attrs: { row: "" } },
                                        "v-radio-group",
                                        bind,
                                        false
                                      ),
                                      on
                                    ),
                                    _vm._l(_vm.gender_options, function(
                                      option,
                                      index
                                    ) {
                                      return _c("v-radio", {
                                        key: index,
                                        attrs: { value: index, label: option }
                                      })
                                    }),
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          977662777
                        )
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4" } },
                [
                  _c("with-validation", {
                    attrs: { field: "height" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-select",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      items: _vm.resources.heights,
                                      "menu-props": {
                                        auto: true,
                                        offsetY: true,
                                        contentClass: "big-menu renter-height"
                                      },
                                      "item-text": "name",
                                      "item-value": "value",
                                      dense: ""
                                    },
                                    on: {
                                      click: _vm.scrollHeight,
                                      change: _vm.heightChanged
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.getHeightText(item)
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.getHeightText(item)
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-select",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4" } },
                [
                  _c("with-validation", {
                    attrs: { field: "weight" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-text-field",
                              _vm._g(
                                _vm._b(
                                  {
                                    directives: [
                                      {
                                        name: "mask",
                                        rawName: "v-mask",
                                        value: "###",
                                        expression: "'###'"
                                      }
                                    ],
                                    attrs: { dense: "", maxLength: "3" },
                                    on: { change: _vm.weightChanged }
                                  },
                                  "v-text-field",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "4" } },
                [
                  _c("with-validation", {
                    attrs: { field: "shoe_size" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-select",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      items: _vm.shoe_sizes,
                                      "menu-props": {
                                        auto: true,
                                        offsetY: true,
                                        contentClass: "big-menu shoe-size"
                                      },
                                      "item-text": "name",
                                      "item-value": "model",
                                      dense: ""
                                    },
                                    on: {
                                      click: _vm.scrollShoeSize,
                                      change: _vm.shoeSizeChanged
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "selection",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.getShoeSize(item)
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "item",
                                          fn: function(ref) {
                                            var item = ref.item
                                            return [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.getShoeSize(item)
                                                  ) +
                                                  "\n                        "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-select",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("with-validation", {
                    attrs: { field: "skier_type" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-select",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      "menu-props": "left",
                                      items: _vm.resources.skier_types,
                                      "item-text": "title",
                                      "item-value": "id"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append-outer",
                                          fn: function() {
                                            return [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.ui__openModalByName(
                                                        {
                                                          name:
                                                            "dialog_skier_types"
                                                        }
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c("v-icon", [
                                                    _vm._v(
                                                      "mdi-information-outline"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-select",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "6", md: "6" } },
                [
                  _c("with-validation", {
                    attrs: { field: "package_id" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var bind = ref.bind
                          var on = ref.on
                          return [
                            _c(
                              "v-select",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      items: _vm.packages,
                                      "item-text": "title",
                                      "item-value": "id"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changePackage()
                                      },
                                      "click:append-outer": function($event) {
                                        return _vm.$emit("show-rates")
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "append-outer",
                                          fn: function() {
                                            return [
                                              !_vm.hide_rate
                                                ? _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { icon: "" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.ui__openModalByName(
                                                            {
                                                              name:
                                                                "dialog_rental_rates"
                                                            }
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("v-icon", [
                                                        _vm._v(
                                                          "mdi-information-outline"
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  "v-select",
                                  bind,
                                  false
                                ),
                                on
                              )
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _vm.show_addons == 1
                    ? [
                        _c("v-divider", { staticClass: "mx-0" }),
                        _vm._v(" "),
                        _c(
                          "v-row",
                          [
                            _c(
                              "v-col",
                              { attrs: { md: "12" } },
                              [
                                _c("h5", [_vm._v("Add-ons")]),
                                _vm._v(" "),
                                _vm._l(_vm._originalPackageAddons, function(
                                  addon
                                ) {
                                  return _c("v-checkbox", {
                                    key: "checkbox__package_addon_" + addon.id,
                                    staticClass: "mt-0",
                                    attrs: {
                                      "hide-details": true,
                                      multiple: "",
                                      label:
                                        addon.title +
                                        (!_vm.$store.state.model.reservation
                                          .group_link_id &&
                                        _vm.do_not_show_price_on_checkout !=
                                          1 &&
                                          !(
                                            _vm.$store.state.model.reservation
                                              ._type == "advance" &&
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal &&
                                            _vm.no_priceing_checkouts == 1
                                          )
                                          ? " (" +
                                            (_vm.is_in_special_period &&
                                            !_vm.$store.state.model.reservation
                                              .is_seasonal
                                              ? "$" +
                                                (
                                                  parseFloat(
                                                    addon.price.replace("$", "")
                                                  ) +
                                                  (parseFloat(
                                                    addon.price.replace("$", "")
                                                  ) *
                                                    _vm.special_period_increase) /
                                                    100
                                                ).toFixed(2)
                                              : addon.price) +
                                            ")"
                                          : ""),
                                      value: addon.id
                                    },
                                    on: { change: _vm.addonsChanged },
                                    model: {
                                      value: _vm.addonsList_x,
                                      callback: function($$v) {
                                        _vm.addonsList_x = $$v
                                      },
                                      expression: "addonsList_x"
                                    }
                                  })
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [_c("errors-alert", { attrs: { errors: _vm.v__getErrors() } })],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mb-5",
              attrs: { color: "primary" },
              on: { click: _vm.saveForm }
            },
            [_vm._v("Save")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }